import React, { useState, useContext, useEffect } from 'react'
import { useQuery } from '@apollo/react-hooks'
import { Button, Select } from 'antd'
import history from 'CustomHistory'
import _isEmpty from 'lodash/isEmpty'
import sumBy from 'lodash/sumBy'
import first from 'lodash/first'
import _map from 'lodash/map'
import _get from 'lodash/get'

import client from 'apollo'
import ILTS from './Tables/ILTS'
import Stock from './Tables/Stock'
import Ledger from './Tables/Ledger'
import NoData from 'components/NoData'
import { AppContext } from 'AppContext'
import { sendMePdf } from 'utils/Graph'
import Page404 from 'components/Page404'
import DownloadReport from '../DownloadReport'
import Loader from 'components/loaders/Loader'
import OpenPosition from './Tables/OpenPosition'
import { GET_ILTS_REPORT } from '../graphql/Queries'
import { GET_STRATEGY } from 'modules/Settings/graphql/Queries'
import '../index.css'

const { Option } = Select

export default function () {
  const [strategy, setStrategy] = useState('1005')
  const [sendMeLoading, setSendMeLoading] = useState(false)
  const [strategyList, setStrategyList] = useState(undefined)
  const { state: { currentUser: { clientCode, id } } } = useContext(AppContext)
  const { data, loading, error } = useQuery(GET_ILTS_REPORT, { variables: { where: { clientCode, date: null, strategy } }, fetchPolicy: "network-only" })
  useEffect(() => {
    client.query({ query: GET_STRATEGY, variables: { where: { clientCode } }, fetchPolicy: 'network-only' })
      .then((res) => {
        if (_get(res, 'data.getStrategy')) {
          setStrategyList(_get(res, 'data.getStrategy'))
          if (res.data.getStrategy.length === 1) {
            setStrategy(res.data.getStrategy[0].StrategyCode)
          }
        }
      })
      .catch(() => setStrategyList([]))
  }, [clientCode])


  let spIltsreport
  let futuresOptionsReport = {}
  let stockReport = {}
  let ledgerReport = {}

  if (!loading && _get(data, 'spIltsreport')) {
    spIltsreport = data.spIltsreport[0]
    const reportFutures = spIltsreport.filter((report, key) => (report.Script && report.Script.startsWith('OPTIDX ')))
    futuresOptionsReport = reportFutures.map((reportFuture) => {
      return {
        ...reportFuture,
        TotalQty: Math.round(reportFuture.TotalQty),
        TradedRate: Math.round(reportFuture.TradedRate),
        CMP: Math.round(reportFuture.CMP),
        Value: Math.round(reportFuture.Value),
        Pnl: Math.round(reportFuture.Pnl),
      }
    })
    futuresOptionsReport = [
      ...futuresOptionsReport,
      {
        Script: 'Total',
        TotalQty: sumBy(futuresOptionsReport, 'TotalQty'),
        Value: sumBy(futuresOptionsReport, 'Value'),
        Pnl: sumBy(futuresOptionsReport, 'Pnl'),
      },
    ]

    const reportStocks = spIltsreport.filter((report, key) => (report.Script && !report.Script.startsWith('OPTIDX ')))
    stockReport = reportStocks.map((reportStock) => {
      return {
        ...reportStock,
        TotalQty: Math.round(reportStock.TotalQty),
        TradedRate: Math.round(reportStock.TradedRate),
        CMP: Math.round(reportStock.CMP),
        Value: Math.round(reportStock.Value),
        Pnl: Math.round(reportStock.Pnl),
      }
    })
    stockReport = [
      ...stockReport,
      {
        Script: 'Total',
        TotalQty: sumBy(stockReport, 'TotalQty'),
        Value: sumBy(stockReport, 'Value'),
        Pnl: sumBy(stockReport, 'Pnl'),
      },
    ]

    const ledgers = spIltsreport.filter((report, key) => ((key !== 0 && key !== 1 && key !== 2) && !report.Script))
    ledgerReport = ledgers.map((reportLedger) => {
      return {
        ...reportLedger,
        DR_Amount: Math.round(reportLedger.DR_Amount),
        CR_Amount: Math.round(reportLedger.CR_Amount),
      }
    })
    ledgerReport = [
      ...ledgerReport,
      {
        Entrydate: 'Total',
        DR_Amount: sumBy(ledgerReport, 'DR_Amount'),
        CR_Amount: sumBy(ledgerReport, 'CR_Amount'),
        remark: '',
      },
      {
        Entrydate: 'Net Value',
        DR_Amount: sumBy(ledgerReport, 'CR_Amount') - sumBy(ledgerReport, 'DR_Amount'),
        CR_Amount: '',
        remark: '',
      },
    ]

  }

  const spILTSReportData = spIltsreport && _map(spIltsreport, (report, key) => {

    if (key === 0)
      return report
    if (report.ClientCode) delete report.ClientCode
    return report
  })

  return (
    <>
      <div className="send-me-wrapper">
        <Button
          type='primary'
          // loading={sendMeLoading}
          onClick={() => history.push(`/reports/performance/${id}/comparison-of-fund/${clientCode}`)}
        >
          View comparison
        </Button>
        <Button
          type='primary'
          loading={sendMeLoading}
          onClick={() => {
            setSendMeLoading(true)
            sendMePdf('ILTS-PDF')
              .then(() => setSendMeLoading(false))
          }}
        >
          Send Me
        </Button>
        <Select
          defaultValue='1005'
          style={{ width: 80 }}
          className='gx-mr-3 gx-select-sm'
          onChange={(e) => setStrategy(e)}
          loading={!strategyList}
        >
          {
            _map(strategyList, (strategy, key) => {
              const { StrategyName, StrategyCode } = strategy
              return <Option value={StrategyCode} key={key}>{StrategyName}</Option>
            })
          }
        </Select>
        <DownloadReport data={spILTSReportData} fileName='ILTS' id='ILTS-PDF' />

      </div>
      {
        loading ?
          <Loader />
          :
          error ?
            <Page404 />
            :
            (!_get(data, 'spIltsreport')) || _isEmpty(_get(data, 'spIltsreport[0]')) ?
              <NoData />
              :
              <div className='report-table-wrapper ilts-report-client' id='ILTS-PDF'>
                <div className='report-ILTS' id='ILTS-PDF-Client'>
                  {/* <DownloadReport data={first(spIltsreport)} fileName='ILTS' id='ILTS-PDF-Client' /> */}
                  <ILTS reportData={first(spIltsreport)} ledgerReport={ledgerReport} />
                </div>
                <br />
                <br />
                <div className='report-ILTS' id='ILTS-PDF-Stock' onClick={() => history.push(`/reports/trade-eq`)}>
                  <DownloadReport className="ExportAS" data={stockReport} onlyCSV fileName='ILTS-stock' id='ILTS-PDF-Stock' />
                  <Stock reportData={stockReport} />
                </div>
                <br />
                <br />
                <div className='report-ILTS' id='ILTS-PDF-Futures' onClick={() => history.push(`/reports/trade-fo`)}>
                  <DownloadReport className="ExportAS" data={futuresOptionsReport} onlyCSV fileName='ILTS-futures-options' id='ILTS-PDF-Futures' />
                  <OpenPosition reportData={futuresOptionsReport} />
                </div>
                <br />
                <br />
                <div className='report-ILTS' id='ILTS-PDF-Ledger'>
                  <DownloadReport className="ExportAS" data={ledgerReport} fileName='ILTS-ledger' id='ILTS-PDF-Ledger' />
                  <Ledger reportData={ledgerReport} clientData={first(spIltsreport)} />
                </div>
              </div>
      }
    </>
  )
}
